import { render, staticRenderFns } from "./website-contact-banner.vue?vue&type=template&id=22736724&scoped=true&"
import script from "./website-contact-banner.vue?vue&type=script&lang=js&"
export * from "./website-contact-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22736724",
  null
  
)

export default component.exports